import type { UserContribStatusCountType } from '~/model/UserContribStatusCountType';

export function checkContributionCount({
  count,
  value = 0,
  key = 'initialized',
}: {
  count: UserContribStatusCountType;
  value?: number;
  key?: keyof UserContribStatusCountType;
}) {
  return count?.[key] >= value;
}
